import comingSoonSmall from "@images/coming_soon_small.webp";
import comingSoonLarge from "@images/coming_soon_large.webp";

export function comingSoonImages() {
    return {
        small: comingSoonSmall,
        large: comingSoonLarge,
    }
}